import {GetAnalysisPipelineStep, GetAnalysisStepData} from 'analysis-tool/AnalysisTypes';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

export default function getOutputStepDataForDataFrame(
  step: GetAnalysisPipelineStep,
  dataFrameId: string
): GetAnalysisStepData | null {
  return (
    step.outputStepDatas.find(
      (stepData) =>
        stepData.kind === PipelineStepDataKind.DATASET &&
        stepData.dataFrames.some((dataFrame) => dataFrame.id === dataFrameId)
    ) ?? null
  );
}

export function getOutputStepDataForChart(
  step: GetAnalysisPipelineStep,
  chartId: string
): GetAnalysisStepData | null {
  return (
    step.outputStepDatas.find(
      (stepData) =>
        stepData.kind === PipelineStepDataKind.CHART &&
        stepData.charts.some((chart) => (!isInaccessible(chart) ? chart.id === chartId : false))
    ) ?? null
  );
}
